import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const DiplomaElectricalEngineeringCoursePage: React.FC = () => {
  const courseData = {
    title: "Diploma in Electrical Engineering",
    shortName: "DEE",
    duration: "3 years",
    description: "Technical program covering electrical systems, power generation, and industrial automation",
    overview: "Diploma in Electrical Engineering is a 3-year technical program that provides comprehensive knowledge of electrical systems, power generation, transmission, distribution, and industrial automation. This course combines theoretical learning with extensive practical training in electrical laboratories and workshops, preparing students for careers in power sector, manufacturing, and electrical services.",
    eligibility: [
      "10th pass from recognized board",
      "Minimum 50% marks in 10th (45% for SC/ST)",
      "Mathematics and Science as compulsory subjects",
      "Good understanding of basic electrical concepts"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Engineering Mathematics",
          "Engineering Physics", 
          "Basic Electrical Engineering",
          "Electrical Workshop",
          "Engineering Drawing",
          "Digital Electronics"
        ]
      },
      {
        year: 2,
        subjects: [
          "Electrical Machines",
          "Power Systems",
          "Electrical Measurements",
          "Control Systems",
          "Electrical Installation",
          "Electronics Engineering"
        ]
      },
      {
        year: 3,
        subjects: [
          "Power Electronics",
          "Industrial Automation",
          "Electrical Maintenance",
          "Renewable Energy Systems",
          "Project Management",
          "Industrial Training & Project"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Electrical Technician",
        "Power Plant Operator",
        "Maintenance Engineer",
        "Control Room Operator",
        "Field Service Engineer",
        "Electrical Supervisor",
        "Quality Control Inspector",
        "Safety Officer",
        "Installation Technician",
        "Technical Sales Representative"
      ],
      industries: [
        "Power Generation Companies",
        "Electrical Equipment Manufacturing",
        "Industrial Automation",
        "Renewable Energy",
        "Railways & Metro",
        "Steel & Cement Plants",
        "Oil & Gas Industry",
        "Construction Industry",
        "Electrical Contracting",
        "Government Power Departments"
      ],
      averageSalary: "₹2.5-5.5 LPA (Fresher), ₹7-18 LPA (Experienced)",
      topRecruiters: [
        "NTPC, BHEL, PowerGrid",
        "Tata Power, Adani Power",
        "L&T Electrical, ABB",
        "Siemens, Schneider Electric",
        "Indian Railways",
        "State Electricity Boards"
      ]
    },

    admissionProcess: [
      "State Polytechnic Entrance Test",
      "Merit-based admission on 10th marks",
      "Counselling and seat allotment",
      "Document verification",
      "Medical fitness certificate",
      "Fee payment and college reporting"
    ],

    topColleges: [
      {
        name: "Government Polytechnic College",
        location: "Chennai",
        fees: "₹15,000",
        ranking: "Government College"
      },
      {
        name: "PSG Polytechnic College",
        location: "Coimbatore",
        fees: "₹45,000",
        ranking: "Private - NAAC A+"
      },
      {
        name: "Thiagarajar Polytechnic College",
        location: "Salem",
        fees: "₹35,000",
        ranking: "Private - Autonomous"
      },
      {
        name: "Government Polytechnic",
        location: "Tiruchirappalli",
        fees: "₹18,000",
        ranking: "Government College"
      }
    ],

    skills: [
      "Electrical Circuit Analysis",
      "Power System Operation",
      "Industrial Automation",
      "Electrical Safety",
      "Motor Control Systems",
      "PLC Programming",
      "Electrical Installation",
      "Maintenance Techniques",
      "Troubleshooting",
      "Quality Control"
    ],

    futureScope: "Excellent opportunities in renewable energy, smart grids, electric vehicles, and industrial automation with government's focus on clean energy and electrification.",

    faqs: [
      {
        question: "What are the safety requirements for electrical work?",
        answer: "Electrical work requires strict safety protocols including protective equipment, safety training, and following electrical codes. Industrial training emphasizes safety as a top priority."
      },
      {
        question: "Can I work in power plants after diploma?",
        answer: "Yes, power plants actively recruit diploma holders for technician and operator positions. Many PSUs like NTPC, BHEL have specific recruitment for diploma holders."
      },
      {
        question: "Is there scope in renewable energy sector?",
        answer: "Absolutely! Solar, wind, and other renewable energy projects need skilled electrical technicians for installation, maintenance, and operation of power systems."
      },
      {
        question: "Can I start an electrical contracting business?",
        answer: "Yes, many diploma holders become electrical contractors, providing installation, maintenance, and repair services for residential, commercial, and industrial clients."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default DiplomaElectricalEngineeringCoursePage;
